import React from "react";
import PictureListItem from "@/react/Webshop/Components/Retouch/PictureListItem";
import makeStyles from "@material-ui/styles/makeStyles";
const useStyles = makeStyles((theme) => ({
    list: {
        margin: 0,
        padding: 0,
        listStyle: "none",
        "& > li": {
            marginBottom: theme.spacing(3),
        },
    },
}));
const PictureList = ({ pictureUuids, product, picturesSubProducts, handleToggleSubProduct, }) => {
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement("ul", { className: classes.list }, pictureUuids.map((pictureUuid) => {
            var _a;
            return (React.createElement("li", { key: pictureUuid },
                React.createElement(PictureListItem, { pictureUuid: pictureUuid, product: product, pictureSubProducts: (_a = picturesSubProducts[pictureUuid]) !== null && _a !== void 0 ? _a : [], handleToggleSubProduct: handleToggleSubProduct(pictureUuid) })));
        }))));
};
export default PictureList;
